import layout from '@/layout'

export default {
  path: '/log',
  component: layout,
  redirect: '/log/index',
  name: 'AdminLog',
  meta: {
    title: 'other',
    icon: 'other'
  },
  children: [
    {
      path: '/config/log',
      name: 'AdminLog',
      component: () => import('@/views/system/admin_log/index'),
      meta: {
        title: 'AdminLog',
        icon: 'log'
      }
    }
  ]
}
